"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryDrawResultUpdateInputSchema = exports.APosLotteryDrawResultCreateInputSchema = exports.APosLotteryDrawResultSchema = exports.APosLotteryDrawResultSourceSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLotteryDrawResultSourceSchema = zod_1.z.enum(['manual', 'api']);
exports.APosLotteryDrawResultSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    resultId: id_schema_1.EntityIdSchema,
    gameId: id_schema_1.EntityIdSchema,
    drawDate: zod_1.z.string().describe('ISO date string for the draw'),
    winningNumbers: zod_1.z.array(zod_1.z.number().int()),
    bonusNumber: zod_1.z.number().int().optional(),
    prizeBreakdown: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional().describe('Map of prize tier to amount in cents'),
    isVerified: zod_1.z.boolean().default(false),
    source: exports.APosLotteryDrawResultSourceSchema.default('manual'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotteryDrawResultCreateInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    drawDate: zod_1.z.string(),
    winningNumbers: zod_1.z.array(zod_1.z.number().int()).min(1),
    bonusNumber: zod_1.z.number().int().optional(),
    prizeBreakdown: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
    isVerified: zod_1.z.boolean().optional(),
    source: exports.APosLotteryDrawResultSourceSchema.optional(),
});
exports.APosLotteryDrawResultUpdateInputSchema = exports.APosLotteryDrawResultCreateInputSchema.partial();
//# sourceMappingURL=lottery-draw-result.schema.js.map